const lang = require('./lang')

const language = function () {
  switch (lang.checkLang()) {
    case 'zh':
      return require('./charset/zh_cn')
    case 'en':
      return require('./charset/en')
    default:
      return require('./charset/zh_cn')
  }
}

module.exports = language()



// WEBPACK FOOTER //
// ./src/assets/lang/index.js